'use client';

import React from 'react';

import AccordionBlock from '@/components/accordion-block';
import ContactFormBlock from '@/components/contact-form-block';
import ContentBlock from '@/components/content-block';
import ContentGridBlock from '@/components/content-grid-block';
import ContentMediaBlock from '@/components/content-media-block';
import SafetyFeatureShowcaseBlock from '@/components/safety-feature-showcase-block';

import { type HsiycContentMatrix } from '@tac/sanity-client/types';
import { type Dereference } from '@tac/sanity-client/type-utils';

export type Block = Dereference<HsiycContentMatrix>[number];

type ContentMatrixProps = {
  blocks?: Dereference<HsiycContentMatrix>;
};

const ContentMatrix = ({ blocks = [] }: ContentMatrixProps) => {
  return (
    <div className="legacy-typography">
      {blocks?.map((block) => {
        switch (block._type) {
          case 'hsiycAccordionBlock':
            return <AccordionBlock key={block._key} {...block} />;
          case 'hsiycContactFormBlock':
            return <ContactFormBlock key={block._key} {...block} />;
          case 'hsiycContentBlock':
            return <ContentBlock key={block._key} {...block} />;
          case 'hsiycContentGridBlock':
            return <ContentGridBlock key={block._key} {...block} />;
          case 'hsiycContentMediaBlock':
            return <ContentMediaBlock key={block._key} {...block} />;
          case 'hsiycSafetyFeatureShowcaseBlock':
            return <SafetyFeatureShowcaseBlock key={block._key} {...block} />;
        }
      })}
    </div>
  );
};

export default ContentMatrix;
